/*
 *  Author: DL
 *  Date: 2020-12-03 18:31:45
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-04 09:42:29
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';

export default function(props) {
  const { className } = props;
  return <span className={`icon iconfont ${className}`} />;
}
